module.exports = __webpack_public_path__ + "img/placeholder-box.0e4b8f1b.png";